import { gsap } from 'gsap';

const ResponsiveCarousel = (config) => {
  const container = config.container ? document.getElementById(config.container) : null;
  const prev = config.prev ? document.getElementById(config.prev) : null;
  const next = config.next ? document.getElementById(config.next) : null;
  const prevMobile = config.prevMobile ? document.getElementById(config.prevMobile) : null;
  const nextMobile = config.nextMobile ? document.getElementById(config.nextMobile) : null;
  if (!container || !prev || !next) return;

  const slides = container.children;
  const quantity = slides.length;
  if (quantity === 0) return;

  let currentSlide;
  let nextSlide;
  let prevSlide;
  let currentIndex = 0;
  let isAnimating = false;
  let autorotate = config.autorotate || false;
  const autorestart = autorotate;

  let rotation;
  const indicatorsContainer = document.getElementById(config.indicators);
  const indicators = indicatorsContainer ? indicatorsContainer.children : [];

  function setupIndicators() {
    if (indicators.length === 0) {
      indicatorsContainer.style.display = 'none';
      return;
    }
    const loadFromIndicator = (e) => {
      stopRotation();
      const index = parseInt(e.target.getAttribute('data-index'), 10);
      if (currentIndex < index) {
        slideInNext(index);
      } else if (currentIndex > index) {
        slideInPrev(index);
      }
    };

    for (let i = 0; i < slides.length; i++) {
      indicators[i].addEventListener('click', loadFromIndicator, false);
      indicators[i].addEventListener('touch', loadFromIndicator, false);
    }
  }

  function stopRotation() {
    if (autorotate) {
      autorotate = false;
      clearTimeout(rotation);
    }
  }

  function startRotation() {
    if (autorotate && autorestart) {
      rotation = setInterval(slideInNext, 5000);
    }
  }

  function restartRotation() {
    if (autorestart && !autorotate) {
      if (!isAnimating) {
        autorotate = true;
        rotation = setInterval(slideInNext, 5000);
      }
    }
  }

  function observe() {
    if (prev && next) {
      prev.addEventListener('click', (e) => {
        e.preventDefault();
        stopRotation();
        if (!isAnimating) slideInPrev();
      }, false);
      next.addEventListener('click', (e) => {
        e.preventDefault();
        stopRotation();
        if (!isAnimating) slideInNext();
      }, false);
      prev.addEventListener('touch', (e) => {
        e.preventDefault();
        stopRotation();
        if (!isAnimating) slideInPrev();
      }, false);
      next.addEventListener('touch', (e) => {
        e.preventDefault();
        stopRotation();
        if (!isAnimating) slideInPrev();
      }, false);
      if (prevMobile && nextMobile) {
        prevMobile.addEventListener('click', (e) => {
          e.preventDefault();
          stopRotation();
          if (!isAnimating) slideInPrev();
        }, false);
        nextMobile.addEventListener('click', (e) => {
          e.preventDefault();
          stopRotation();
          if (!isAnimating) slideInNext();
        }, false);
      }
    }
    // @todo: add Draggable interface instead
    // $(container).swipe({
    //   swipeLeft(event, direction, distance, duration, fingerCount, fingerData) {
    //     stopRotation();
    //     if (!isAnimating) slideInNext();
    //   },
    //   swipeRight(event, direction, distance, duration, fingerCount, fingerData) {
    //     stopRotation();
    //     if (!isAnimating) slideInPrev();
    //   },
    // });
  }

  function getCurrentSlide() {
    for (let j = 0, len = slides.length; j < len; j++) {
      if (slides[j].classList.contains('current')) {
        currentIndex = j;
        currentSlide = slides[j];
        break;
      }
    }
    if (!currentSlide) {
      [currentSlide] = slides;
      slides[0].classList.add('current');
      indicators[0].classList.add('current');
    }
  }

  function clearCurrentIndicator() {
    indicators[currentIndex].classList.remove('current');
  }

  function setCurrentIndicator() {
    indicators[currentIndex].classList.add('current');
  }

  function slideInNext(byIndicatorIndex) {
    isAnimating = true;
    getCurrentSlide();
    clearCurrentIndicator();
    if (byIndicatorIndex === undefined) {
      if ((currentIndex + 1) < quantity) {
        ++currentIndex;
      } else {
        currentIndex = 0;
      }
    } else {
      currentIndex = byIndicatorIndex;
    }

    nextSlide = slides[currentIndex];
    setCurrentIndicator();
    const timeline = gsap.timeline({
      onComplete() {
        nextSlide.classList.add('current');
        currentSlide.classList.remove('current');
        currentSlide.setAttribute('style', '');
        gsap.set(nextSlide, {
          position: 'relative',
        });
        currentSlide = nextSlide;
        isAnimating = false;
        restartRotation();
      },
    });

    timeline
      .addLabel('prep')
      .set(nextSlide, {
        position: 'absolute',
        x: '100%',
        display: 'block',
      }, 'prep')
      .set(currentSlide, {
        position: 'absolute',
      }, 'prep')
      .addLabel('move-next')
      .to(currentSlide, 0.6, {
        x: '-100%',
        ease: 'cubic-bezier(0.4, 0.0, 1, 1)',
      }, 'move-next')
      .to(nextSlide, 0.6, {
        x: '0%',
        ease: 'cubic-bezier(0.4, 0.0, 1, 1)',
      }, 'move-next');
  }

  function slideInPrev(byIndicatorIndex) {
    isAnimating = true;
    getCurrentSlide();
    clearCurrentIndicator();
    if (byIndicatorIndex !== undefined) {
      console.log('byIndicator >', byIndicatorIndex);
      currentIndex = byIndicatorIndex;
    } else if ((currentIndex - 1) >= 0) {
      --currentIndex;
    } else {
      currentIndex = quantity - 1;
    }

    prevSlide = slides[currentIndex];
    setCurrentIndicator();
    const timeline = gsap.timeline({
      onComplete() {
        currentSlide.classList.remove('current');
        prevSlide.classList.add('current');
        currentSlide.setAttribute('style', '');
        gsap.set(prevSlide, {
          position: 'relative',
        });
        currentSlide = prevSlide;
        isAnimating = false;
        restartRotation();
      },
    });

    timeline
      .addLabel('prep')
      .set(prevSlide, {
        display: 'block',
        position: 'absolute',
        x: '-100%',
      }, 'prep')
      .set(currentSlide, {
        position: 'absolute',
      }, 'prep')
      .addLabel('move-prev')
      .to(prevSlide, 0.6, {
        x: '0%',
        ease: 'cubic-bezier(0.4, 0.0, 1, 1)',
      }, 'move-prev')
      .to(currentSlide, 0.6, {
        x: '100%',
        ease: 'cubic-bezier(0.4, 0.0, 1, 1)',
      }, 'move-prev');
  }

  function setup() {
    setupIndicators();
    observe();
    startRotation();
  }

  setup();
};

export default ResponsiveCarousel;
